export default __webpack_public_path__ + "mini-icon-ios-14@2x.png";